import { render, staticRenderFns } from "./DiffCheck.vue?vue&type=template&id=6e63f3d9&scoped=true&"
import script from "./DiffCheck.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DiffCheck.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DiffCheck.vue?vue&type=style&index=0&id=6e63f3d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e63f3d9",
  null
  
)

export default component.exports